/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
} from '@marriott/mi-common-static-components';
import { StaticWrapper } from '@marriott/mi-trc-components';
import { RFPComponent } from '@marriott/mi-trc-components';

MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/reference/v1/reference`)(StaticWrapper, {
  emptyLabel: 'StaticWrapper',
  isEmpty: false,
});

MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/rfp/v1/rfp-meetings`)(RFPComponent, {
  emptyLabel: 'RFPComponent',
  isEmpty: false,
});

MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/rfp/v1/rfp-weddings`)(RFPComponent, {
  emptyLabel: 'RFPComponent',
  isEmpty: false,
});

MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/static-wrapper/v1/static-wrapper`)(StaticWrapper, {
  emptyLabel: 'StaticWrapper',
  isEmpty: false,
});

MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
  props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
  {
    emptyLabel: 'NavigationContainerWrapper',
    isEmpty: false,
  }
);

MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
  emptyLabel: 'NavigationUtilityLinkWrapper',
  isEmpty: false,
});

MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
  emptyLabel: 'NavigationWrapper',
  isEmpty: false,
});
